import { render, staticRenderFns } from "./createCompany.vue?vue&type=template&id=fc654952&scoped=true"
import script from "./createCompany.vue?vue&type=script&lang=js"
export * from "./createCompany.vue?vue&type=script&lang=js"
import style0 from "./createCompany.vue?vue&type=style&index=0&id=fc654952&prod&scoped=true&lang=css"
import style1 from "./createCompany.vue?vue&type=style&index=1&id=fc654952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc654952",
  null
  
)

export default component.exports